import JobRibbon from './job-ribbon';

export default class JobRibbonDesktop extends JobRibbon {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/job-ribbon/job-ribbon.desktop.js